
import TranResourcesApi from './src/Tranresources'
import MailList from './src/MailList'


let apis = {
   TranResourcesApi,
   MailList
};

export default apis;
